module.exports = __webpack_public_path__ + "static/heavens-on-earth-04161556cc203c5225658725054e262a.jpg";